<template lang="pug">
  .statistics-overview
    GenericTable()
      tr(slot="thead")
        th Period
        th Orders
        th Expansions
        th Codes
        th Valid
        th Verified
        th Invalid
      tr(v-for="d in data")
        td {{d.period}}
        td {{d.orders | number}}
        td {{d.expansions | number}}
        td {{d.codes | number}}
        td {{d.valid | number}}
        td {{d.verified | number}}
        td {{d.invalid | number}}
</template>

<script>
import GenericTable from '@/components/common/GenericTable'
import { numberFilter } from '@/filters/filters'

export default {
  props: {
    data: {
      type: Array
    }
  },
  components: {
    GenericTable
  },
  filters: {
    number: numberFilter
  }
}
</script>

<style lang="scss">
.statistics-overview {
  tr:last-child {
    background-color: #efefef;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/core/statistic/Overview.vue